import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const leads: AppRouteModule = {
  path: '/clue',
  name: 'Clue',
  component: LAYOUT,
  redirect: '/clue/index',
  meta: {
    icon: 'icon-park-outline:clue',
    title: '线索',
    hideChildrenInMenu: true,
    auth: 'leads',
    orderNo: 10,
  },
  children: [
    {
      path: 'index',
      name: 'Leads',
      component: () => import('/@/views/admin/clue/index.vue'),
      meta: {
        title: '线索列表',
        hideMenu: true,
        ignoreKeepAlive: false,
        setting: {
          action: 'index',
          controller: 'leads',
          module: 'crm',
          types: 'crm_leads',
        },
        auth: 'leads.index',
      },
    },
    {
      path: 'detail/:id',
      name: 'ClueDetail',
      component: () => import('/@/views/admin/clue/ClueDetail.vue'),
      meta: {
        title: '线索详情',
        hideMenu: true,
        ignoreKeepAlive: true,
        currentActiveMenu: '/clue/index',
        setting: {
          action: 'read',
          controller: 'leads',
          module: 'crm',
          types: 'crm_leads',
        },
        auth: 'leads.read',
      },
    },
  ],
};

export default leads;
